import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MenuLinks from "../menu/MenuLinks";
import { MenuData } from "../menu/MenuData";
import styles from "../utilities/cssmodules/Sidebar.module.css";
import logo from "../../images/lcc_logo.png";

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();

  // Include all menu items in main menu except Feedback and Support
  const mainMenuLinks = MenuData.filter(
    (item) =>
      item.permissionCategoryName !== "Feedback" &&
      item.permissionCategoryName !== "Help & Support Center",
  );

  // Find Feedback and Support for bottom container
  const bottomMenuLinks = MenuData.filter(
    (item) =>
      item.permissionCategoryName === "Feedback" ||
      item.permissionCategoryName === "Help & Support Center",
  );

  // Debug: Log menu items and rendering time
  useEffect(() => {
    const startTime = performance.now();


    const endTime = performance.now();
  }, [isOpen, mainMenuLinks, bottomMenuLinks]);

  const gotoDashboard = () => {
    console.log("Navigating to Dashboard...");
    navigate("/dashboard");
    if (isOpen) toggleSidebar();
  };

  return (
    <div
      className={`${styles["sidebar-component-container"]} ${isOpen ? styles.active : ""}`}
      aria-hidden={!isOpen}
    >
      <div className={styles["sidebar-component-top-container"]}>
        <div
          className={styles["login_component_logo_divider"]}
          onClick={gotoDashboard}
        >
          <span className={styles.logo_container}>
            <img src={logo} alt="lcc logo" className={styles.logo_1} />
            {/* <span data-tour="system-menu" className={styles.text_1}>
            </span> */}
          </span>
        </div>
        <div className={styles["sidebar-nav-container"]}>
          <MenuLinks menuItems={mainMenuLinks} toggleSidebar={toggleSidebar} />
        </div>
      </div>

      {/* <div className={styles["sidebar-component-bottom-container"]}> */}
      {/*   <MenuLinks menuItems={bottomMenuLinks} toggleSidebar={toggleSidebar} /> */}
      {/* </div> */}
    </div>
  );
};

export default React.memo(Sidebar);
